<template>
  <b-modal v-model="visible" size="lg" centered scrollable header-class="bg-modal-header" class="modal-dialog-right">

    <template #modal-header>
      <div class="fw-bold">{{ !$_utils.isEmpty(modalType) ? typeOptions[modalType].title : '' }} 현황</div>
    </template>

    <div class="row">
      <div class="col-xl-12">
        <div class="card mb-0">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 ct-mb-padding-top-50 ct-mb-margin-bottom-100">
                <apexchart ref="dashboardModalDonutChart" type="donut" height="200"
                           :options="chartDonutOptions" :series="chartDonutOptions.series" />
              </div>
              <div class="col-lg-6">
                <table class="dashboard-modal-table">
                  <thead>
                  <tr>
                    <th>유형</th>
                    <th>
<!--                      <span class="ct-padding-right-50">{{ typeOptions[modalType]?.title || '' }}</span>-->
                      <span class="ct-padding-right-50">{{ !$_utils.isEmpty(modalType) ? typeOptions[modalType].title : '' }}</span>
                      <span class="text-muted">({{ !$_utils.isEmpty(modalType) ? typeOptions[modalType].unit : '' }})</span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th>회원</th>
                    <td>{{ $_utils.comma(count.member) }}</td>
                  </tr>
                  <tr>
                    <th>로밍</th>
                    <td>{{ $_utils.comma(count.roaming) }}</td>
                  </tr>
                  <tr>
                    <th>비회원</th>
                    <td>{{ $_utils.comma(count.nonMember) }}</td>
                  </tr>
                  <tr class="last-tr">
                    <th>합계</th>
                    <td>{{ $_utils.comma(count.total) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="visible=false">닫기</b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
import { http } from '@/mdk/auth-api';

export default {
  props: {
    modalType: String
  },
  data() {
    return {
      visible: false,
      typeOptions: {
        use: { title: '이용', unit: '건' },
        user: { title: '이용자', unit: '명' },
        chargePower: { title: '충전량', unit: 'kWh' },
        chargeCost: { title: '충전금액', unit: '원' }
      },
      items: null,
      chartDonutOptions: {
        chart: {
          type: 'donut',
          fontFamily: 'NanumSquareRound',
        },
        // fill: {
        //   type: 'gradient'
        // },
        legend: {
          show: true,
          fontSize: '14px',
          offsetX: 0,
          offsetY: 0
        },
        labels: ['회원', '로밍', '비회원'],
        colors: ['#2cb57e', '#f5bd58', '#adb5bd'],
        /*grid: {
          padding: {
            bottom: -80
          }
        },*/
        dataLabels: {
          formatter: (value, { seriesIndex, dataPointIndex, w }) => {
            if (value > 4.99) {
              //const name = w.config.labels[seriesIndex];
              //return [name, value.toFixed(1) + '%'];
              return value.toFixed(1) + '%';
            } else {
              return '';
            }
          },
          style: {
            fontSize: '13px',
            fontWeight: 400
          },
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 5,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#adb5bd',
            opacity: 0.9
          },
          dropShadow: {
            enabled: false
          }
        },
        tooltip: {
          fillSeriesColor: false,
          theme: 'light',
          y: {
            formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
              return value.toLocaleString() + ' ' + this.typeOptions[this.modalType].unit;
            }
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: 14,
              minAngleToShowLabel: 10
            },
            donut: {
              size: '60%',
              labels: {
                show: true,
                name: {
                  offsetY: -8,
                  formatter: (val) => {
                    return val;
                  },
                },
                value: {
                  show: true,
                  offsetY: 2
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '합계',
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#9b9b9b',
                  formatter: (w) => {
                    const sum = w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                    return sum.toLocaleString();
                  }
                }
              }
            }
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        series: [0, 0, 0]
      },
      count: { member: 0, nonMember: 0, roaming: 0, total: 0 },
    }
  },
  methods: {
    show() {
      const vm = this;
      vm.getItems();

      vm.visible = true;
    },
    getItems() {
      const vm = this;
      const _url = '/onmapi/dashboard/tran-detail';

      http.get(_url)
          .then((res) => {
            vm.items = res.data.items;

            if (vm.items.length > 0) vm.setModalData();
          })
          .catch(err => {
            console.error('Dashboard Modal Data Error :: ', err)
          });
    },
    setModalData() {
      const vm = this;

      const userCount = { member: 0, nonMember: 0, roaming: 0, total: 0 };
      const useCount = { member: 0, nonMember: 0, roaming: 0, total: 0 };
      const powerCount = { member: 0, nonMember: 0, roaming: 0, total: 0 };
      const costCount = { member: 0, nonMember: 0, roaming: 0, total: 0 };

      vm.items.forEach(item => {
        if (item.userType === '회원') {
          userCount.member = item.userCount;
          useCount.member = item.usedCount;
          powerCount.member = item.totEnergy;
          costCount.member = item.totCost;
        } else if (item.userType === '비회원') {
          userCount.nonMember = item.userCount;
          useCount.nonMember = item.usedCount;
          powerCount.nonMember = item.totEnergy;
          costCount.nonMember = item.totCost;
        } else if (item.userType === '로밍') {
          userCount.roaming = item.userCount;
          useCount.roaming = item.usedCount;
          powerCount.roaming = item.totEnergy;
          costCount.roaming = item.totCost;
        } else if (item.userType === '합계') {
          userCount.total = item.userCount;
          useCount.total = item.usedCount;
          powerCount.total = item.totEnergy;
          costCount.total = item.totCost;
        }
      });

      if (this.modalType === 'use') {
        vm.count = Object.assign({}, useCount);
      } else if (this.modalType === 'user') {
        vm.count = Object.assign({}, userCount);
      }  else if (this.modalType === 'chargePower') {
        vm.count = Object.assign({}, powerCount);
      } else if (this.modalType === 'chargeCost') {
        vm.count = Object.assign({}, costCount);
      }

      vm.drawChart();
    },
    drawChart() {
      const vm = this;
      vm.$refs.dashboardModalDonutChart.updateSeries([vm.count.member, vm.count.roaming, vm.count.nonMember]);
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-dialog {
    //margin-right: 16px;
  }
}
</style>
